import React from 'react'

import AirpodsProImg from '../assets/images/Airpods Pro Clone.png'
import airpods_pro_responsive from "../assets/images/airpods-pro-responsive.png"
import airpods_pro_video from "../assets/videos/airpods-pro-video.mp4"
import next_prev from "../assets/images/log-out.png"

import { motion } from 'framer-motion'
import ReactPlayer from 'react-player'
import "./Project.scss"
import { useNavigate } from 'react-router'


const content = (isFirstMount) => ({
    animate: {
        transition: { staggerChildren: 0.1, delayChildren: isFirstMount ? 2.8 : 0 },
    },
});

const title = {
    initial: { y: -20, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.6, -0.05, 0.01, 0.99],
        },
    },
};

export default function AirpodsPro({ isFirstMount }) {

    let navigate = useNavigate();
    function handleClick() {
        navigate("/");
    }
    return (
        <motion.div exit={{ opacity: 0 }} className="individual_ones">
            {isFirstMount && <InitialTransition />}
            <motion.div
                initial="initial"
                animate="animate"
                variants={content(isFirstMount)}
                className="first6"
            >
                <section className="project_banner">
                    <div className="header">
                        <span className="" onClick={handleClick}>
                            Back To Main
                        </span>
                    </div>
                    <motion.div className="project_name"
                        variants={title}
                        style={{ wordSpacing: "20px" }}>
                        Airpods Pro Clone
                    </motion.div>
                    <motion.div className="banner_image"
                        variants={title}>
                        <img src={AirpodsProImg} alt="Fakeflix Banner"
                            loading='lazy'
                        />
                    </motion.div>
                </section>
                <section className="project_description">
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            An individual attempt in replicating Apple's Airpods Pro Website
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Timeline
                            </div>
                            <div className="para_details">
                                September 2021 - October 2021
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Description
                            </div>
                            <div className="para_details">
                                <p>
                                    This is an educational casestudy where I tried to precisely
                                    replicate the famous <a href="https://www.apple.com/in/airpods-pro/">Apple's Airpods Pro</a>
                                    website, including their slick video playing on scroll. The intent was to
                                    learn all the unique animations used in the original website along with
                                    adding my own features to give originality.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Link
                            </div>
                            <div className="para_details">
                                <a href="https://apple-airpods-pro.vercel.app/"
                                    target='_blank' rel='noreferrer'>
                                    apple-airpods-pro.vercel.app
                                </a>
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Solution
                            </div>
                            <div className="para_details">
                                <p>
                                    The project was created in WebFlow. The main theme of the whole
                                    website is the video animation playing on scroll. I used the same
                                    logic as that of creating video playback on scroll using frames, ie,
                                    when we scroll, depending on the current position, next or the previous
                                    frame is played. I also created a text fade continuous loader using CSS.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="demo_video">
                        <ReactPlayer
                            className='react-player fixed-bottom'
                            url={airpods_pro_video}
                            width='100%'
                            height='100%'
                            loop={true}
                            muted={true}
                            controls={false}
                            playing={true}
                        />
                    </div>
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            TYPOGAPHY
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Oswald
                            </div>
                            <div className="para_details">
                                Title Text
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "'Oswald', sans-serif" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                sans-serif
                            </div>
                            <div className="para_details">
                                Paragraph Text
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: 'sans-serif' }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Julius Sans One
                            </div>
                            <div className="para_details">
                                Loader Text
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: 'Julius Sans One' }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="project_footer">
                    <div className="responsive_image">
                        <img src={airpods_pro_responsive} alt=""
                            style={{ width: "100%", height: "100%" }}
                            loading='lazy'
                        />
                    </div>
                    <div className="other_projects">
                        <a href="/cambrian" className="prev_project">
                            <img src={next_prev} alt="previous project" className="rotate"
                                loading='lazy'
                            />
                            <span>Previous Project</span>
                        </a>
                        <a href="/fakeflix" className="next_project">
                            <span>Next Project</span>
                            <img src={next_prev} alt="next project"
                                loading='lazy'
                            />
                        </a>
                    </div>
                </section>
            </motion.div>
        </motion.div>
    )
}





const blackBox = {
    initial: {
        height: "100vh",
        bottom: 0,
    },
    animate: {
        height: 0,
        transition: {
            when: "afterChildren",
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};

const textContainer = {
    initial: {
        opacity: 1,
        width: "100%"
    },
    animate: {
        opacity: 0,
        transition: {
            duration: 0.3,
            when: "afterChildren",
        },
    },
};

const text = {
    initial: {
        y: 40,
    },
    animate: {
        y: 80,
        transition: {
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};


const InitialTransition = () => {

    return (
        <motion.div
            className="first1"
            initial="initial"
            animate="animate"
            variants={blackBox}
            onAnimationStart={() => {
                document.body.classList.add("overflow-hidden")
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            onAnimationComplete={() => {
                document.body.classList.remove("overflow-hidden")
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
        >
            <motion.svg variants={textContainer} className="first2">
                <pattern
                    id="pattern"
                    patternUnits="userSpaceOnUse"
                    width={750}
                    height={800}
                    className="text-white"
                >
                    <rect className="first3" />
                    <motion.rect
                        variants={text}
                        className="first4"
                    />
                </pattern>
                <text
                    className="first5"
                    textAnchor="middle"
                    x="50%"
                    y="50%"
                    style={{ fill: "url(#pattern)" }}
                >
                    airpods pro
                </text>
            </motion.svg>
        </motion.div>
    );
};